// extracted by mini-css-extract-plugin
export default {"bgColor":"Background_bgColor__n9OVK","bgImage":"Background_bgImage__1EF9l"};